import React from "react";
import {
  TextField,
  Grid,
  FormControlLabel,
  Switch,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
} from "@material-ui/core";
import { Field } from "formik";
import QueueSelect from "../QueueSelect";

const TransferTab = ({
  classes,
  tabStates,
  handleCheckboxChange,
  setFieldValue,
  transferQueueId,
  setTransferQueueId,
  transferWhatsappId,
  setTransferWhatsappId,
  loadingWhatsapps,
  whatsapps,
  theme,
}) => {
  return (
    <>
                  {/* ✅ OPTIMIZADO: Header más compacto */}
                  <div className={classes.sectionHeader}>
                    <Typography variant="h6" color="primary" style={{ marginBottom: '4px' }}>
                      <span role="img" aria-label="transferencia">🔄</span> Transferencias Automáticas
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontSize: '0.85rem' }}>
                      Configuración de transferencias por tiempo e inactividad
                    </Typography>
                  </div>

                  {/* ✅ AGRUPACIÓN 1: TRANSFERENCIAS POR TIEMPO */}
                  <div className={classes.checkboxSection}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={tabStates.transfersEnabled}
                          onChange={(e) => handleCheckboxChange('transfersEnabled', e.target.checked, setFieldValue)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="subtitle1" color="primary" style={{ fontWeight: 600 }}>
                          <span role="img" aria-label="transferencia">🔄</span> Activar Transferencias por Tiempo
                        </Typography>
                      }
                    />
                    <Typography variant="body2" color="textSecondary" style={{ marginLeft: 24, fontSize: '0.85rem' }}>
                      {tabStates.transfersEnabled 
                        ? "Transferir tickets automáticamente después de un tiempo específico sin respuesta"
                        : "Los campos están deshabilitados y se mantendrán vacíos"
                      }
                    </Typography>
                  </div>

                  {tabStates.transfersEnabled && (
                    <div className={classes.tabContent}>
                      <Grid container spacing={2}>
                        {/* ✅ OPTIMIZADO: Minutos + Departamento en la misma fila - COMPACTOS */}
                        <Grid item xs={12} sm={6}>
                          <Field name="timeToTransfer">
                            {({ field, meta }) => (
                              <TextField
                                {...field}
                                fullWidth
                                type="number"
                                label={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="cronómetro">⏱️</span> Minutos</span>}
                                error={meta.touched && Boolean(meta.error)}
                                helperText={(meta.touched && meta.error) || "Ej: 30 = transferir después de 30 minutos"}
                                variant="outlined"
                                margin="dense"
                                inputProps={{ min: 1, step: 1, style: { fontSize: '0.875rem', padding: '8px 12px', height: '40px' } }}
                                className={classes.textFieldCompact}
                                value={field.value || ''}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                InputLabelProps={{
                                  style: { fontSize: '0.875rem' }
                                }}
                                FormHelperTextProps={{
                                  style: { fontSize: '0.75rem', marginTop: '4px' }
                                }}
                              />
                            )}
                          </Field>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <div className={classes.compactSelectWrapper}>
                            <QueueSelect
                              selectedQueueIds={transferQueueId}
                              onChange={(selectedId) => {
                                setTransferQueueId(selectedId)
                                if (!selectedId) {
                                  setFieldValue('timeToTransfer', '');
                                }
                              }}
                              multiple={false}
                              title={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="diana">🎯</span> Departamento Destino</span>}
                              required
                            />
                          </div>
                        </Grid>
                        {/* ✅ Conexión WhatsApp (full width) - COMPACTO */}
                        <Grid item xs={12}>
                          <FormControl 
                            fullWidth 
                            variant="outlined" 
                            margin="dense"
                            className={classes.formControlCompact}
                          >
                            <InputLabel style={{ fontSize: '0.875rem' }}>
                              <span role="img" aria-label="Conexión WhatsApp">📱</span> Conexión WhatsApp (Opcional)
                            </InputLabel>
                            <Select
                              value={transferWhatsappId}
                              onChange={(e) => {
                                setTransferWhatsappId(e.target.value);
                              }}
                              label={
                                <span>
                                  <span role="img" aria-label="Conexión WhatsApp">📱</span> Conexión WhatsApp (Opcional)
                                </span>
                              }
                              disabled={loadingWhatsapps}
                              style={{ backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#fff' }}
                              renderValue={() => {
                                if (transferWhatsappId === "" || !transferWhatsappId) {
                                  return (
                                    <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                      <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                      <span>Usar conexión del ticket (por defecto)</span>
                                    </div>
                                  );
                                }
                                const whatsapp = whatsapps.find(w => w.id === Number(transferWhatsappId));
                                if (!whatsapp) {
                                  return (
                                    <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                                      <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                      <span>Seleccione una conexión</span>
                                    </div>
                                  );
                                }
                                return (
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                        {whatsapp.name || `Conexión ${whatsapp.id}`}
                                      </span>
                                      <span style={{ fontSize: '12px', color: '#666' }}>
                                        {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                         whatsapp.name ? whatsapp.name : 
                                         `Conexión ${whatsapp.id}`}
                                      </span>
                                    </div>
                                  </div>
                                );
                              }}
                            >
                              <MenuItem value="">
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                  <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="Por defecto">🔄</span>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                      Usar conexión del ticket (por defecto)
                                    </span>
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                      El ticket se transferirá usando la misma conexión WhatsApp
                                    </span>
                                  </div>
                                </div>
                              </MenuItem>
                              {whatsapps && Array.isArray(whatsapps) && whatsapps.map((whatsapp) => (
                                <MenuItem key={whatsapp.id} value={whatsapp.id} style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <span style={{ marginRight: '6px', fontSize: '14px' }} role="img" aria-label="WhatsApp">📱</span>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                                      <span style={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
                                        {whatsapp.name || `Conexión ${whatsapp.id}`}
                                      </span>
                                      <span style={{ fontSize: '0.75rem', color: '#666' }}>
                                        {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                                         whatsapp.name ? whatsapp.name : 
                                         `Conexión ${whatsapp.id}`}
                                      </span>
                                    </div>
                                    <span style={{ 
                                      padding: '2px 6px', 
                                      borderRadius: '10px', 
                                      fontSize: '0.65rem',
                                      backgroundColor: whatsapp.status === 'CONNECTED' ? '#4CAF50' : '#f44336',
                                      color: 'white',
                                      marginLeft: '6px'
                                    }}>
                                      {whatsapp.status === 'CONNECTED' ? 'CONECTADO' : 'DESCONECTADO'}
                                    </span>
                                  </div>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>
                  )}

                  {/* ✅ AGRUPACIÓN 2: CIERRE POR INACTIVIDAD */}
                  <div className={classes.checkboxSection} style={{ marginTop: 16 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={tabStates.inactivityEnabled}
                          onChange={(e) => handleCheckboxChange('inactivityEnabled', e.target.checked, setFieldValue)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="subtitle1" color="primary" style={{ fontWeight: 600 }}>
                          <span role="img" aria-label="reloj">⏰</span> Activar Cierre por Inactividad
                        </Typography>
                      }
                    />
                    <Typography variant="body2" color="textSecondary" style={{ marginLeft: 24, fontSize: '0.85rem' }}>
                      {tabStates.inactivityEnabled 
                        ? "Cerrar tickets automáticamente después de un período de inactividad"
                        : "Los campos están deshabilitados y se mantendrán vacíos"
                      }
                    </Typography>
                  </div>

                  {tabStates.inactivityEnabled && (
                    <div className={classes.tabContent}>
                      <Grid container spacing={2}>
                        {/* ✅ OPTIMIZADO: Minutos + Mensaje en la misma fila - COMPACTOS */}
                        <Grid item xs={12} sm={6}>
                          <Field name="expiresTicket">
                            {({ field, meta }) => (
                              <TextField
                                {...field}
                                fullWidth
                                type="number"
                                label={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="reloj">⏰</span> Minutos</span>}
                                variant="outlined"
                                margin="dense"
                                error={meta.touched && Boolean(meta.error)}
                                helperText={(meta.touched && meta.error) || "Ej: 60 = cerrar después de 60 minutos"}
                                inputProps={{ min: 1, step: 1, style: { fontSize: '0.875rem', padding: '8px 12px', height: '40px' } }}
                                className={classes.textFieldCompact}
                                value={field.value || ''}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                InputLabelProps={{
                                  style: { fontSize: '0.875rem' }
                                }}
                                FormHelperTextProps={{
                                  style: { fontSize: '0.75rem', marginTop: '4px' }
                                }}
                              />
                            )}
                          </Field>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Field name="expiresInactiveMessage">
                            {({ field, meta }) => (
                              <TextField
                                {...field}
                                label={<span style={{ fontSize: '0.875rem' }}><span role="img" aria-label="mensaje">💬</span> Mensaje de Cierre</span>}
                                multiline
                                rows={2}
                                fullWidth
                                error={meta.touched && Boolean(meta.error)}
                                helperText={(meta.touched && meta.error) || "Mensaje enviado antes de cerrar"}
                                variant="outlined"
                                margin="dense"
                                className={classes.textFieldCompact}
                                value={field.value || ''}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                InputProps={{
                                  style: { fontSize: '0.875rem', padding: '8px 12px' }
                                }}
                                InputLabelProps={{
                                  style: { fontSize: '0.875rem' }
                                }}
                                FormHelperTextProps={{
                                  style: { fontSize: '0.75rem', marginTop: '4px' }
                                }}
                              />
                            )}
                          </Field>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                
    </>
  );
};

export default TransferTab;
